export default __webpack_public_path__ + "video-classification3f98ce.png";